import * as analyticsActions from 'actions/analytics';
import mixpanel from 'mixpanel-browser';
import tabbalytics from 'utils/libraries/tabbalytics';

mixpanel.init('a87544d35384f140fdbbe3b115c2855c');

const initialState = {};

const analyticsReducer = (state = initialState, action) => {
  switch (action.type) {
    case analyticsActions.TRACK_EVENT:
      tabbalytics.track(
        action.payload.name,
        action.payload.booking,
        action.payload.user_id,
        action.payload.data
      );
      break;
    default:
      break;
  }

  return state;
};

export default analyticsReducer;



// WEBPACK FOOTER //
// ./src/reducers/analytics/index.js